import { render, staticRenderFns } from "./TransferReverse.vue?vue&type=template&id=5a7d0802&scoped=true"
import script from "./TransferReverse.vue?vue&type=script&lang=js"
export * from "./TransferReverse.vue?vue&type=script&lang=js"
import style0 from "./TransferReverse.vue?vue&type=style&index=0&id=5a7d0802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d0802",
  null
  
)

export default component.exports